import CheckCircleIcon from '@heroicons/react/outline/CheckCircleIcon'
import clsx from 'clsx'

import { Button } from '@tribeplatform/react-ui-kit/Button'

import { useAnalytics } from '../../hooks/useAnalytics'

export const MemberOnboardingStep = ({ step }) => {
  const analytics = useAnalytics()

  return (
    <div className="flex">
      <div
        className={clsx(
          'rounded-lg p-5 text-content text-center flex-shrink-0 w-52 flex flex-col',
          step.completed
            ? 'opacity-60 bg-surface-subdued'
            : 'bg-surface-subdued',
        )}
      >
        <div className="justify-center flex mb-3">
          {step.completed ? (
            <CheckCircleIcon className="w-8 h-8 text-action-primary" />
          ) : (
            <step.icon className="w-8 h-8" />
          )}
        </div>
        <h3 className="text-base font-medium">{step.title}</h3>
        <div className="text-content-subdued flex-grow text-sm">
          {step.description}
        </div>
        <div className="mt-6">
          {step.completed ? (
            <div className="text-action-primary font-medium px-4 py-2 text-base">
              {step.button.completed}
            </div>
          ) : (
            <Button
              size="lg"
              variant={step?.button?.variant || 'outline'}
              onClick={() => {
                step?.button?.action?.()
                analytics.track('Click Onboarding', {
                  title: step.title,
                  id: step.id,
                })
              }}
            >
              {step?.button?.cta}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
